import { render, staticRenderFns } from "./MultipleSelectionTable.vue?vue&type=template&id=f2af5426"
import script from "./MultipleSelectionTable.vue?vue&type=script&lang=js"
export * from "./MultipleSelectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports